import React from "react";
import {Box, ListItemButton, Tooltip, Typography} from "@mui/material";
import {RAIL, rgba} from "../rail/railTokens";

/**
 * One row inside a {@link ListBlock}.
 *
 * - `label`    text shown in the row
 * - `onClick`  row click handler
 * - `active`   selected look (accent pill)
 * - `action`   optional trailing element (e.g. an edit icon button); it is
 *              revealed on row hover. Stop propagation in its handler if it
 *              should not also trigger `onClick`.
 * - `tooltip`  optional tooltip text (handy for truncated names)
 */
export const SideItemRow = ({label, onClick, active = false, action = null, tooltip}) => {
    const row = (
        <ListItemButton
            disableRipple
            onClick={onClick}
            sx={{
                position: "relative",
                minHeight: 0,
                px: 1,
                py: 0.5,
                my: 0.15,
                borderRadius: "8px",
                color: active ? RAIL.accent : RAIL.muted,
                backgroundColor: active ? rgba(RAIL.accent, 0.12) : "transparent",
                transition: "background-color .12s ease, color .12s ease",
                "&:hover": {
                    backgroundColor: rgba(RAIL.accent, active ? 0.16 : 0.08),
                    color: active ? RAIL.accent : RAIL.ink,
                },
                "&:hover .side-row-action": {opacity: 1},
            }}
        >
            <Typography
                noWrap
                sx={{flex: 1, fontSize: 12.5, fontWeight: active ? 600 : 500, color: "inherit"}}
            >
                {label}
            </Typography>
            {action && (
                <Box
                    className="side-row-action"
                    sx={{display: "flex", alignItems: "center", ml: 0.5, opacity: 0, transition: "opacity .12s ease"}}
                >
                    {action}
                </Box>
            )}
        </ListItemButton>
    );

    return tooltip
        ? <Tooltip title={tooltip} placement="right" disableInteractive enterDelay={400}>{row}</Tooltip>
        : row;
};
